import { createReducer, on } from '@ngrx/store'
import { HubtypeCaseFilter } from 'models/hubtype-case-filter'
import { HubtypeCaseSort } from 'models/hubtype-case-sort'
import {
  dismissAnnouncementBanner,
  setAddonContactRequested,
  setAgentsRealtimeColumns,
  setAnalyticsDebugEventsVisible,
  setCopilotQueryRating,
  setCopilotSidePanelWidth,
  setInboxCasesFilter,
  setInboxCasesSort,
  setInboxSelectedQueues,
  setUseInboxV2,
  toggleNavbarCollapse,
  toggleQueuePanelCollapse,
} from '../actions/user-settings.actions'
import { AddonId } from '../constants/addons'

export interface UserSettingsState {
  isNavBarCollapsed: boolean
  isQueuePanelCollapsed?: boolean
  agentsRealtimeColumns?: Record<string, boolean>
  isInboxV2Selected?: boolean
  inboxCasesSort?: HubtypeCaseSort
  inboxCasesFilter?: HubtypeCaseFilter
  inboxSelectedQueueIds?: string[]
  analyticsDebugEventsVisible?: boolean
  copilotSidePanelWidth?: number
  dismissedAnnouncementBanners?: Record<string, string>
  addonContactRequested?: Partial<Record<AddonId, boolean>>
  copilotQueryRatings?: Record<string, 'positive' | 'negative'>
}

export const initialState: UserSettingsState = {
  isNavBarCollapsed: true,
  isQueuePanelCollapsed: false,
  isInboxV2Selected: true,
}

export const reducer = createReducer(
  initialState,
  on(toggleNavbarCollapse, state => ({
    ...state,
    isNavBarCollapsed: !state.isNavBarCollapsed,
  })),
  on(toggleQueuePanelCollapse, state => ({
    ...state,
    isQueuePanelCollapsed: !state.isQueuePanelCollapsed,
  })),
  on(setAgentsRealtimeColumns, (state, { columnsByKey }) => ({
    ...state,
    agentsRealtimeColumns: { ...columnsByKey },
  })),
  on(setUseInboxV2, (state, { useInboxV2 }) => ({
    ...state,
    isInboxV2Selected: useInboxV2,
  })),
  on(setInboxCasesSort, (state, { inboxCasesSort }) => ({
    ...state,
    inboxCasesSort,
  })),
  on(setInboxCasesFilter, (state, { inboxCasesFilter }) => ({
    ...state,
    inboxCasesFilter,
  })),
  on(setInboxSelectedQueues, (state, { inboxSelectedQueueIds }) => ({
    ...state,
    inboxSelectedQueueIds,
  })),
  on(setAnalyticsDebugEventsVisible, (state, { visible }) => ({
    ...state,
    analyticsDebugEventsVisible: visible,
  })),
  on(setCopilotSidePanelWidth, (state, { width }) => ({
    ...state,
    copilotSidePanelWidth: width,
  })),
  on(dismissAnnouncementBanner, (state, { key, version }) => ({
    ...state,
    dismissedAnnouncementBanners: {
      ...(state.dismissedAnnouncementBanners ?? {}),
      [key]: version,
    },
  })),
  on(setAddonContactRequested, (state, { addonId }) => ({
    ...state,
    addonContactRequested: {
      ...(state.addonContactRequested ?? {}),
      [addonId]: true,
    },
  })),
  on(setCopilotQueryRating, (state, { messageId, rating }) => ({
    ...state,
    copilotQueryRatings: {
      ...(state.copilotQueryRatings ?? {}),
      [messageId]: rating,
    },
  }))
)
